// removed by extract-text-webpack-plugin
module.exports = {"acheivements":"acheivements__2q3kJ","headingWrapper":"headingWrapper__1R9I5","heading":"heading__3J7H4","mainDescription":"mainDescription__6XQYK"};


//////////////////
// WEBPACK FOOTER
// ./components/articleItem/style.scss
// module id = O1O2
// module chunks = 9